<template>
  <v-app>
    <v-row
      justify="space-around"
      class="mt-5 mx-0 d-flex justify-center"
    >
      <v-chip-group
        v-model="period"
        column
        active-class="primary--text"
      >
        <v-chip
          large
          label
          class="mx-2"
          value="0"
        >
          <h2>ماهانه</h2>
        </v-chip>
        <v-chip
          large
          label
          class="mx-2"
          value="10"
        >
          <h2>شش ماهه</h2> &nbsp; &nbsp;   <h3 style="color: #e91e63">
            (  10% تخفیف   )
          </h3>
        </v-chip>
        <v-chip
          large
          label
          class="mx-2"
          value="20"
        >
          <h2>یک ساله</h2> &nbsp; &nbsp;   <h3 style="color: #e91e63">
            (  20% تخفیف   )
          </h3>
        </v-chip>
      </v-chip-group>
    </v-row>
    <div
      :class="{'d-flex': !isMobile}"
      class="justify-center"
    >
      <v-card
        v-for="(plan, key) in plans"
        :key="key"
        :width="(!isMobile ? '18%' : '98%')"
        class="mx-1 pt-3"
      >
        <v-toolbar
          height="40"
          flat
        >
          <v-spacer />
          <h2>{{ plan.name }}</h2>
          <v-spacer />
        </v-toolbar>
        <v-toolbar
          height="40"
          flat
        >
          <v-spacer />
          <p>{{ plan.subTitle }}</p>
          <v-spacer />
        </v-toolbar>
        <v-toolbar
          v-show="!getPlan"
          height="40"
          flat
        >
          <v-spacer />
          <h3 v-if="plan.price">
            {{ $numberFormat(+plan.price - +((period/100)*plan.price)) }}  تومان
          </h3>  <h4 v-if="plan.price">
            /   در ماه
          </h4>
          <h3 v-if="plan.priceContent">
            {{ plan.priceContent }}
          </h3>
          <v-spacer />
        </v-toolbar>
        <div align="center">
          <v-btn
            color="#0066FF"
            class="mx-auto"
            @click="getAbr(plan.value)"
            width="80%"
          >
            انتخاب طرح و شروع رایگان
            <v-icon
              color="white"
            >
              mdi-arrow-left-thin
            </v-icon>
          </v-btn>
        </div>

        <v-list dense>
          <v-list-item class="py-0">
            <v-list-item-icon class="ml-1">
              <v-icon
                color="green darken-2"
              >
                mdi-check-bold
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title
                v-if="plan.documentCount < 100000"
                v-text="' حداکثر ' + plan.documentCount + '  سند در ماه'"
              />
              <v-list-item-title
                v-if="plan.documentCount > 100000"
                v-text="'تعداد سند نامحدود'"
              />
            </v-list-item-content>
          </v-list-item>
          <v-list-group
            v-for="item in plan.items"
            :key="item.title"
            v-model="item.active"
            no-action
          >
            <template v-slot:activator>
              <v-list-item-icon class="ml-1">
                <v-icon
                  :color="item.actionColor"
                >
                  {{ item.action }}
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                  style="white-space:normal !important;line-height: normal;"
                  v-text="item.title"
                />
              </v-list-item-content>
            </template>
            <template v-slot:appendIcon>
              <v-icon
                v-show="item.items"
                color="blue-grey"
                style="font-size: 25px"
              >
                mdi-chevron-down
              </v-icon>
            </template>

            <v-list-item
              v-for="child in item.items"
              :key="child.title"
              dense
              class="py-0"
            >
              <v-list-item-content>
                <v-list-item-title v-text="child.title" />
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </v-list>
      </v-card>
    </div>
  </v-app>
</template>
<script>
  export default {
    data: () => ({
      period: '0',
      plans: [
        {
          name: 'طرح یک',
          value: 'plan1',
          subTitle: 'کسب و کارت رو راه بنداز',
          documentCount: 200,
          price: 190000,
          items: [
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              title: 'تعداد کاربر نامحدود',
            },
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              // active: true,
              items: [
                { title: 'خرید و فروش' },
                { title: 'مدیریت انبار ها' },
                { title: 'کالاها و خدمات' },
                { title: 'هزینه و درآمد' },
                { title: 'دریافت و پرداخت' },
                { title: 'بانک و خزانه داری' },
                { title: 'تنخواه گردان' },
                {
                  title: 'مدیریت وظایف',
                },
                {
                  title: 'ارسال پیامک',
                },
                {
                  title: 'پشتیبان گیری خودکار',
                },
                {
                  title: 'اعلان و اطلاع رسانی',
                },
                {
                  title: 'تاریخچه',
                },
                {
                  title: 'اپلکیشن نسخه اندروید',
                },
                {
                  title: 'اتصال به کارتخوان',
                },
                {
                  title: 'بهای تمام شده',
                },
              ],
              title: 'تمام امکانات حسابداری',
            },
            {
              action: 'mdi-close-thick',
              actionColor: 'pink',
              title: 'پشتیبانی رایگان',
            },
            {
              action: 'mdi-close-thick',
              actionColor: 'pink',
              title: 'فاکتور آنلاین',
            },
            {
              action: 'mdi-close-thick',
              actionColor: 'pink',
              title: 'حسابداری چند ارزی',
            },
            {
              action: 'mdi-close-thick',
              actionColor: 'pink',
              title: 'سامانه مودیان',
            },
            // {
            //   action: 'mdi-close-thick',
            //   actionColor: 'pink',
            //   title: 'بدون شعبه',
            // },
            {
              action: 'mdi-close-thick',
              actionColor: 'pink',
              title: 'مدیریت تولید',
            },
            {
              action: 'mdi-close-thick',
              actionColor: 'pink',
              title: 'باندل کالا',
            },
            {
              action: 'mdi-close-thick',
              actionColor: 'pink',
              title: 'بازگردانی اسناد',
            },
            {
              action: 'mdi-close-thick',
              actionColor: 'pink',
              title: 'وب سرویس',
            },
            {
              action: 'mdi-close-thick',
              actionColor: 'pink',
              title: 'مدیریت شعب',
            },
            {
              action: 'mdi-close-thick',
              actionColor: 'pink',
              title: 'یکپارچه ساز(دیجی کالا،ووکامرس و ..)',
            },
            {
              action: 'mdi-close-thick',
              actionColor: 'pink',
              title: 'درگاه پرداخت',
            },
            {
              action: 'mdi-close-thick',
              actionColor: 'pink',
              title: 'قفل اسناد',
            },
            {
              action: 'mdi-close-thick',
              actionColor: 'pink',
              title: 'استقرار',
            },
            {
              action: 'mdi-close-thick',
              actionColor: 'pink',
              title: 'دیتابیس اختصاصی',
            },
          ],
        },
        {
          name: 'طرح دو',
          value: 'plan2',
          subTitle: 'مناسب کسب و کار های کوچک',
          documentCount: 400,
          price: 290000,
          items: [
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              title: 'تعداد کاربر نامحدود',
            },
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              // active: true,
              items: [
                { title: 'خرید و فروش' },
                { title: 'مدیریت انبار ها' },
                { title: 'کالاها و خدمات' },
                { title: 'هزینه و درآمد' },
                { title: 'دریافت و پرداخت' },
                { title: 'بانک و خزانه داری' },
                { title: 'تنخواه گردان' },
                {
                  title: 'مدیریت وظایف',
                },
                {
                  title: 'ارسال پیامک',
                },
                {
                  title: 'پشتیبان گیری خودکار',
                },
                {
                  title: 'اعلان و اطلاع رسانی',
                },
                {
                  title: 'تاریخچه',
                },
                {
                  title: 'اپلکیشن نسخه اندروید',
                },
                {
                  title: 'اتصال به کارتخوان',
                },
                {
                  title: 'بهای تمام شده',
                },
              ],
              title: 'تمام امکانات حسابداری',
            },
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              title: 'پشتیبانی رایگان',
            },
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              title: 'فاکتور آنلاین',
            },
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              title: 'حسابداری چند ارزی',
            },
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              title: 'سامانه مودیان',
            },
            // {
            //   action: 'mdi-close-thick',
            //   actionColor: 'pink',
            //   title: 'بدون شعبه',
            // },
            {
              action: 'mdi-close-thick',
              actionColor: 'pink',
              title: 'مدیریت تولید',
            },
            {
              action: 'mdi-close-thick',
              actionColor: 'pink',
              title: 'باندل کالا',
            },
            {
              action: 'mdi-close-thick',
              actionColor: 'pink',
              title: 'بازگردانی اسناد',
            },
            {
              action: 'mdi-close-thick',
              actionColor: 'pink',
              title: 'وب سرویس',
            },
            {
              action: 'mdi-close-thick',
              actionColor: 'pink',
              title: 'مدیریت شعب',
            },
            {
              action: 'mdi-close-thick',
              actionColor: 'pink',
              title: 'یکپارچه ساز(دیجی کالا،ووکامرس و ..)',
            },
            {
              action: 'mdi-close-thick',
              actionColor: 'pink',
              title: 'درگاه پرداخت',
            },
            {
              action: 'mdi-close-thick',
              actionColor: 'pink',
              title: 'قفل اسناد',
            },
            {
              action: 'mdi-close-thick',
              actionColor: 'pink',
              title: 'استقرار',
            },
            {
              action: 'mdi-close-thick',
              actionColor: 'pink',
              title: 'دیتابیس اختصاصی',
            },
          ],
        },
        {
          name: 'طرح سه',
          value: 'plan3',
          subTitle: 'کسب و کارت رو به رشده',
          documentCount: 800,
          price: 550000,
          items: [
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              title: 'تعداد کاربر نامحدود',
            },
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              // active: true,
              items: [
                { title: 'خرید و فروش' },
                { title: 'مدیریت انبار ها' },
                { title: 'کالاها و خدمات' },
                { title: 'هزینه و درآمد' },
                { title: 'دریافت و پرداخت' },
                { title: 'بانک و خزانه داری' },
                { title: 'تنخواه گردان' },
                {
                  title: 'مدیریت وظایف',
                },
                {
                  title: 'ارسال پیامک',
                },
                {
                  title: 'پشتیبان گیری خودکار',
                },
                {
                  title: 'اعلان و اطلاع رسانی',
                },
                {
                  title: 'تاریخچه',
                },
                {
                  title: 'اپلکیشن نسخه اندروید',
                },
                {
                  title: 'اتصال به کارتخوان',
                },
                {
                  title: 'بهای تمام شده',
                },
              ],
              title: 'تمام امکانات حسابداری',
            },
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              title: 'پشتیبانی رایگان',
            },
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              title: 'فاکتور آنلاین',
            },
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              title: 'حسابداری چند ارزی',
            },
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              title: 'سامانه مودیان',
            },
            // {
            //   action: 'mdi-check-bold',
            //   actionColor: 'green darken-2',
            //   title: 'تعداد شعبه 2',
            // },
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              title: 'مدیریت تولید',
            },
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              title: 'باندل کالا',
            },
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              title: 'بازگردانی اسناد',
            },
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              title: 'وب سرویس',
            },
            {
              action: 'mdi-close-thick',
              actionColor: 'pink',
              title: 'مدیریت شعب',
            },
            {
              action: 'mdi-close-thick',
              actionColor: 'pink',
              title: 'یکپارچه ساز(دیجی کالا،ووکامرس و ..)',
            },
            {
              action: 'mdi-close-thick',
              actionColor: 'pink',
              title: 'درگاه پرداخت',
            },
            {
              action: 'mdi-close-thick',
              actionColor: 'pink',
              title: 'قفل اسناد',
            },
            {
              action: 'mdi-close-thick',
              actionColor: 'pink',
              title: 'استقرار',
            },
            {
              action: 'mdi-close-thick',
              actionColor: 'pink',
              title: 'دیتابیس اختصاصی',
            },
          ],
        },
        {
          name: 'طرح چهار',
          value: 'plan4',
          subTitle: 'تبریک! کارت درسته',
          documentCount: 100000000,
          price: 1490000,
          items: [
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              title: 'تعداد کاربر نامحدود',
            },
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              // active: true,
              items: [
                { title: 'خرید و فروش' },
                { title: 'مدیریت انبار ها' },
                { title: 'کالاها و خدمات' },
                { title: 'هزینه و درآمد' },
                { title: 'دریافت و پرداخت' },
                { title: 'بانک و خزانه داری' },
                { title: 'تنخواه گردان' },
                {
                  title: 'مدیریت وظایف',
                },
                {
                  title: 'ارسال پیامک',
                },
                {
                  title: 'پشتیبان گیری خودکار',
                },
                {
                  title: 'اعلان و اطلاع رسانی',
                },
                {
                  title: 'تاریخچه',
                },
                {
                  title: 'اپلکیشن نسخه اندروید',
                },
                {
                  title: 'اتصال به کارتخوان',
                },
                {
                  title: 'بهای تمام شده',
                },
              ],
              title: 'تمام امکانات حسابداری',
            },
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              title: 'پشتیبانی رایگان',
            },
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              title: 'فاکتور آنلاین',
            },
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              title: 'حسابداری چند ارزی',
            },
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              title: 'سامانه مودیان',
            },
            // {
            //   action: 'mdi-check-bold',
            //   actionColor: 'green darken-2',
            //   title: 'تعداد شعبه 4',
            // },
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              title: 'مدیریت تولید',
            },
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              title: 'باندل کالا',
            },
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              title: 'بازگردانی اسناد',
            },
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              title: 'وب سرویس',
            },
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              title: 'مدیریت شعب',
            },
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              title: 'یکپارچه ساز(دیجی کالا،ووکامرس و ..)',
            },
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              title: 'درگاه پرداخت',
            },
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              title: 'قفل اسناد',
            },
            {
              action: 'mdi-close-thick',
              actionColor: 'pink',
              title: 'استقرار',
            },
            {
              action: 'mdi-close-thick',
              actionColor: 'pink',
              title: 'دیتابیس اختصاصی',
            },
          ],
        },
        {
          name: 'لایسنس(دایمی)',
          value: 'license',
          subTitle: 'همه چی رو به راهه',
          documentCount: 100000000,
          priceContent: 'تماس بگیرید',
          items: [
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              title: 'تعداد کاربر نامحدود',
            },
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              // active: true,
              items: [
                { title: 'خرید و فروش' },
                { title: 'مدیریت انبار ها' },
                { title: 'کالاها و خدمات' },
                { title: 'هزینه و درآمد' },
                { title: 'دریافت و پرداخت' },
                { title: 'بانک و خزانه داری' },
                { title: 'تنخواه گردان' },
                {
                  title: 'مدیریت وظایف',
                },
                {
                  title: 'ارسال پیامک',
                },
                {
                  title: 'پشتیبان گیری خودکار',
                },
                {
                  title: 'اعلان و اطلاع رسانی',
                },
                {
                  title: 'تاریخچه',
                },
                {
                  title: 'اپلکیشن نسخه اندروید',
                },
                {
                  title: 'اتصال به کارتخوان',
                },
                {
                  title: 'بهای تمام شده',
                },
              ],
              title: 'تمام امکانات حسابداری',
            },
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              title: 'پشتیبانی رایگان',
            },
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              title: 'فاکتور آنلاین',
            },
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              title: 'حسابداری چند ارزی',
            },
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              title: 'سامانه مودیان',
            },
            // {
            //   action: 'mdi-check-bold',
            //   actionColor: 'green darken-2',
            //   title: 'تعداد شعبه 10',
            // },
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              title: 'مدیریت تولید',
            },
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              title: 'باندل کالا',
            },
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              title: 'بازگردانی اسناد',
            },
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              title: 'وب سرویس',
            },
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              title: 'مدیریت شعب',
            },
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              title: 'یکپارچه ساز(دیجی کالا،ووکامرس و ..)',
            },
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              title: 'درگاه پرداخت',
            },
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              title: 'قفل اسناد',
            },
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              title: 'استقرار',
            },
            {
              action: 'mdi-check-bold',
              actionColor: 'green darken-2',
              title: 'دیتابیس اختصاصی',
            },
          ],
        },
      ],
    }),
    props: ['getPlan'],
    beforeMount () {
      this.$root.$i18n.locale = 'fa'
      // this.$vuetify.rtl = true
    },
    mounted () {
    },
    methods: {
      getAbr (value) {
        if (this.getPlan) {
          this.$emit('input', value)
        } else {
          window.location.href = 'https://abr.abriron.com/register/index?plan=' + value
        }
      },
    },
  }
</script>
<style lang="sass">
@import '~vuetify/src/styles/tools/_rtl.sass'
</style>
